module.exports = __webpack_public_path__ + "static/media/rastreo.20f778f2.png";